import { useInfiniteQuery } from '@tanstack/react-query';
import {
  ClientPaymentStatus,
  getFinancesSaasPayments,
  queryKeys,
} from '@vgrubs/components';
import { SaasRange } from './saasDetails.helpers';

const PAGE_SIZE = 20;

/**
 * Monthly SaaS payments in the range, newest first, a page at a time. The
 * route answers a bare array, so a page shorter than PAGE_SIZE is the end.
 * `status` null = every status; each filter is its own cache slot.
 */
export const useSaasPayments = (
  range: SaasRange,
  status: ClientPaymentStatus | null,
  enabled: boolean
) => {
  const query = useInfiniteQuery({
    queryKey: queryKeys.admin.saasDetails.payments(range, status ?? 'all'),
    initialPageParam: 1,
    queryFn: async ({ pageParam }) => {
      const { data } = await getFinancesSaasPayments({
        ...range,
        page: pageParam,
        limit: PAGE_SIZE,
        ...(status ? { status } : {}),
      });
      return data.data ?? [];
    },
    getNextPageParam: (last, pages) =>
      last.length === PAGE_SIZE ? pages.length + 1 : undefined,
    enabled,
  });

  return {
    payments: query.data?.pages.flat() ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    hasNextPage: !!query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  };
};
